import { useState } from 'react';

import Landing from '../pages/Partners/Landing'
import Step1 from '../pages/Steps/step1'
import Step1b from '../pages/Steps/step1b'
import Step2 from '../pages/Steps/step2'
import Step3 from '../pages/Steps/step3'
import Step4 from '../pages/Steps/step4'
import Step5 from '../pages/Steps/step5'
import Step5b from '../pages/Steps/step5b'
import Step6 from '../pages/Steps/step6'
import Step7 from '../pages/Steps/step7'
import Step8Approve from '../pages/Steps/step8Approve';
import Step8More from '../pages/Steps/step8More';
import Step9 from '../pages/Steps/Step9';
import Step10 from '../pages/Steps/step10';


export default function Onboardingv2(props) {

  const [step, setStep] = useState(0)
  const [validation] = useState(true)
  const [test] = useState(false)

  const [formData, setFormData] = useState({

    // Page 1
    ownerfName: "",
    ownerlName: "",
    emailAddress: "",
    telephoneNumber: "",
    bussinessName: "",
    tradeName: "",
    isPrimaryContact: "",
    legal: "",

    // Page 1.5
    primaryContactfName: "",
    primaryContactlName: "",
    primaryContactPhone: "",
    primaryContactEmail: "",

    // Page 2
    busDesc: "",
    mcc_Iso: "",

    // Page 3
    taxId: "",
    busStart: "",
    incorpStateCode: "State of Incorporation",
    taxStatus: "",
    taxFilingType: "",

    // Page 4
    grossSales: "",
    highestSale: "",
    annualSales: "",
    avgSales: "",
    checkImage: "",

    //Page 5
    busStreet: "",
    busPhone: "",
    busStreet2: "",
    busEmail: "",
    busCity: "",
    busState: "State",
    // busFax: "",
    busZip: "",
    // otherLocation: "",

    // otherStreet: "",
    // otherPhone: "",
    // otherStreet2: "",
    // otherEmail: "",
    // otherCity: "",
    // otherState: "",
    // otherFax: "",
    // otherZip: "",

    //Page 6
    finInst: "",
    finPhone: "",
    checkingNum: "",
    bankABA: "",

    //Page 7
    princName: "",
    princSSN: "",
    princTitle: "",
    princOwnership: "",
    princStreet: "",
    princStreet2: "",
    princAddr: "",
    princDOB: "",
    princCity: "",
    princState: "State",
    princZip: "",

    terminal: "",

    authToken: "",

    appResult: "",
    appRef: "",
    appInternalMID: "",

    test: test,
  })

  // function for going to next step by increasing step state by 1
  const nextStep = () => {
    setStep(step + 1);
  };

  // function for going to next step by increasing step state by 0.5
  const nextHalfStep = () => {
    setStep(step + 0.5);
  };

  // function for going to previous step by decreasing step state by 1
  const prevStep = () => {
    setStep(step - 1);
  };

  // function for going to previous step by decreasing step state by 1
  const prevHalfStep = () => {
    setStep(step - 0.5);
  };

  // handling form input data by taking onchange value and updating our previous form data state
  const handleInputData = input => e => {
    // input value from the form
    let { value } = e.target;
    if (e.target.type === 'checkbox') {
      value = e.target.checked
    }

    //updating for data state taking previous state and then adding new value to create new object
    setFormData(prevState => ({
      ...prevState,
      [input]: value
    }));
  }

  const changeVal = (key, val) => {
    setFormData(prevState => ({
      ...prevState,
      [key]: val
    }));
  }

  switch (step) {
    // case 1 to show stepOne form and passing nextStep, prevStep, and handleInputData as handleFormData method as prop and also formData as value to the form
    case 0:
      if (props.landing === true) {
        return (
          <div className={props.homeContainer}>
            <Landing nextStep={nextStep} changeVal={changeVal} values={formData}
              logo={props.logo} partner={props.partner} landingColor={props.landingColor}
              disclamer={props.disclamer} disclamerTxt={props.disclamerTxt} disclamerTitle={props.disclamerTitle}></Landing>
          </div>
        )
      }
      else {
        nextStep();
        break;
      }
    case 1:
      return (
        <div className={props.container}>
          <Step1 color={props.color} nextStep={nextStep} nextHalfStep={nextHalfStep} handleFormData={handleInputData} values={formData} validation={validation}
            formLogo={props.formLogo}></Step1>
        </div>
      );
    case 1.5:
      return (
        <div className={props.container}>
          <Step1b color={props.color} nextHalfStep={nextHalfStep} handleFormData={handleInputData} prevStep={prevHalfStep} values={formData} validation={validation}></Step1b>
        </div>
      )
    case 2:
      return (
        <div className={props.container}>
          <Step2 color={props.color} nextStep={nextStep} handleFormData={handleInputData} prevStep={prevStep} values={formData} validation={validation} ></Step2>
        </div>
      )
    case 3:
      return (
        <div className={props.container}>
          <Step3 color={props.color} nextStep={nextStep} handleFormData={handleInputData} prevStep={prevStep} values={formData} validation={validation}></Step3>
        </div>

      )
    case 4:
      return (
        <div className={props.container}>
          <Step4 color={props.color} nextStep={nextStep} handleFormData={handleInputData} changeVal={changeVal} prevStep={prevStep} values={formData} validation={validation}></Step4>
        </div>

      )
    case 5:
      return (
        <div className={props.container}>
          <Step5 color={props.color} nextStep={nextStep} nextHalfStep={nextHalfStep} handleFormData={handleInputData} prevStep={prevStep} values={formData} validation={validation}></Step5>
        </div>
      )
    case 5.5:
      return (
        <div className={props.container}>
          <Step5b color={props.color} nextHalfStep={nextHalfStep} handleFormData={handleInputData} prevStep={prevHalfStep} values={formData} validation={validation}></Step5b>
        </div>
      )
    case 6:
      return (
        <div className={props.container}>
          <Step6 color={props.color} nextStep={nextStep} handleFormData={handleInputData} prevStep={prevStep} values={formData} validation={validation}></Step6>
        </div>
      )
    case 7:
      return (
        <div className={props.container}>
          <Step7 color={props.color} nextStep={nextStep} handleFormData={handleInputData} prevStep={prevStep} values={formData} validation={validation}></Step7>
        </div>
      )
    case 8:
      return (
        <div className={props.container}>
          {(formData.annualSales <= 999999 && formData.avgSales <= 99)
            ? <Step8Approve color={props.color} nextStep={nextStep} handleFormData={handleInputData} values={formData} validation={validation}></Step8Approve>
            : <Step8More color={props.color} nextStep={nextStep} handleFormData={handleInputData} values={formData} validation={validation}></Step8More>
          }
        </div>
      )
    case 9:
      return (
        <div className={props.container}>
          <Step9 color={props.color} nextStep={nextStep} changeVal={changeVal} prevStep={prevStep} values={formData}></Step9>
        </div>
      )
    case 10:
      return (
        <div className={props.container}>
          <Step10 color={props.color} nextStep={nextStep} changeVal={changeVal} prevStep={prevStep} values={formData}></Step10>
        </div>
      )
    default:
      return (
        <></>
      )
  }
}

// <Final values = {formData}></Final>